import React, { Fragment } from 'react'
import { ArrowLeftRightIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/shared/components/ui/button'
import { Content } from '@/shared/components/ui/layout'
import {
	ResizableHandle,
	ResizablePanel,
	ResizablePanelGroup,
} from '@/shared/components/ui/resizable'
import {
	Tooltip,
	TooltipContent,
	TooltipTrigger,
} from '@/shared/components/ui/tooltip'
import { ampli } from '@/shared/lib/ampli'
import { cn } from '@/shared/lib/utils'

import { GlobalPcSetToolbar } from './global-pc-set/GlobalPcSetToolbar'
import { PricingCampaignPanel } from './global-pc-set/PricingCampaignPanel'
import { useGlobalPcSets } from './GlobalPcSetsProvider'

export const GlobalSetsContent = () => {
	const { t } = useTranslation()

	const { panels, addPanel } = useGlobalPcSets()

	return (
		<Content className='w-full flex-col overflow-y-auto'>
			<ResizablePanelGroup direction='horizontal'>
				{panels?.length &&
					panels.map((panel, index) => {
						const isLast = index === panels.length - 1

						return (
							<Fragment key={panel.id}>
								<ResizablePanel
									minSize={30}
									className='flex min-w-0 flex-col gap-2 overflow-hidden pt-2'
								>
									<div className='flex h-full min-w-0 flex-col gap-2'>
										<div className='sticky top-0 flex w-full min-w-0 items-center gap-2 px-4'>
											<GlobalPcSetToolbar
												panel={panel}
												// Leave space for the 'Add Panel' button (28px) at the end of the row
												className={cn(isLast && 'w-[calc(100%-28px)]')}
											/>
											{isLast && (
												<Tooltip>
													<TooltipTrigger asChild>
														<Button
															variant='primary'
															size='icon'
															onClick={() => {
																ampli.globalPcSetComparisonActionClicked({
																	global_pc_set_comparison_action: 'add_panel',
																})
																addPanel()
															}}
														>
															<ArrowLeftRightIcon />
														</Button>
													</TooltipTrigger>
													<TooltipContent>
														{t('global_set.compare.tooltip', {
															defaultValue:
																'Compare with other pricing campaigns',
														})}
													</TooltipContent>
												</Tooltip>
											)}
										</div>
										{panel.pricingCampaignId && (
											<PricingCampaignPanel
												pricingCampaignId={panel.pricingCampaignId}
											/>
										)}
									</div>
								</ResizablePanel>
								{index < panels.length - 1 && <ResizableHandle withHandle />}
							</Fragment>
						)
					})}
			</ResizablePanelGroup>
		</Content>
	)
}
